"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ThresholdsBinder = /** @class */ (function () {
    function ThresholdsBinder() {
        var _this = this;
        var names = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            names[_i] = arguments[_i];
        }
        this.bindValues = function () {
            var values = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                values[_i] = arguments[_i];
            }
            var thresholds = [];
            _this.thresholdNames.forEach(function (value, index) {
                var _a;
                thresholds.push({
                    name: value,
                    value: (_a = values[index]) !== null && _a !== void 0 ? _a : 0,
                });
            });
            return thresholds;
        };
        this.thresholdNames = names;
    }
    return ThresholdsBinder;
}());
exports.default = ThresholdsBinder;
